import type { DateRange } from "@/models/common";
import type { FilterState } from "@/store/filters/state";
import { makeState } from "@/store/filters/state";
import { mergeIntoOriginal, MergeOptions } from "@/utils/objectMerging";

/**
 * Sets date range value from the Filtering module.
 * @param state - Vuex state for the Traces module.
 * @param value - DateTime value to be assigned to date range.
 */
export function setDateRange(state: FilterState, value: DateRange): void {
  state.dateRange = value;
}

/**
 * Sets filters value from the Filtering module.
 * @param state - Vuex state for the Filtering module.
 * @param value - String array value to be assigned to filters.
 */
export function setFilters(state: FilterState, value: Array<string>): void {
  state.filters = value;
}

/**
 * Sets isFilterShareable value from the Filtering module.
 * @param state - Vuex state for the Filtering module.
 * @param value - boolean value to be assigned to isFilterShareable.
 */
export function setIsFilterShareable(state: FilterState, value: boolean): void {
  state.isFilterShareable = value;
}

/**
 * Reset the state object to its initial value.
 * @param state - Vuex state for the module.
 * @param options - Key subset modifiers for the reset operation.
 */
export function reset(state: FilterState, options?: MergeOptions): void {
  mergeIntoOriginal(
    state as unknown as Record<string, unknown>,
    makeState() as unknown as Record<string, unknown>,
    options
  );
}
